<script>
	import { updateToolbarImage } from '../../stores/toolbar/UpdateToolbarImage';

	const onSubmit = () => updateToolbarImage(false);
</script>

<div class="proteus-control proteus-group protues-ui-input">
	<button class="proteus-button is-primary" on:click={onSubmit}>Submit</button>
</div>
